import { SearchCanvasesOutput } from "@zapier/bff";
import { trpc } from "../trpc";

type SearchCanvasesCache = SearchCanvasesOutput | undefined;

function removeCanvasFromSearchResults(
  cache: SearchCanvasesCache,
  id: string,
): SearchCanvasesCache {
  if (!cache) {
    return cache;
  }

  return {
    ...cache,
    results: cache.results.filter((canvas) => canvas.id !== id),
    meta: {
      ...cache.meta,
      count: cache.meta?.count ? cache.meta.count - 1 : 0,
    },
  };
}

interface Input {
  folderId?: string; // optional folderId for invalidating the folder assets query
}

export function useDeleteCanvas({ folderId }: Input) {
  const utils = trpc.useUtils();

  return trpc.canvas.delete.useMutation({
    onMutate: ({ id }) => {
      if (folderId) {
        utils.asset.getHydratedFolderAssets.cancel({
          folderId,
        });
      }

      // Remove canvas from the canvas search results cache
      utils.canvas.search.setData({}, (cache: SearchCanvasesCache) =>
        removeCanvasFromSearchResults(cache, id),
      );
    },
    onSettled: () => {
      // Invalidate canvas search results
      utils.canvas.search.invalidate();

      // Invalidate all assets for current folder
      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({
          folderId,
        });
      }
    },
  });
}
